import { Container, Spacer } from '@chakra-ui/react';
import { FC } from 'react';
import CommunityPrivateChannelContainer from 'presentation/containers/modules/community/CommunityPrivateChannelContainer';
import EventCalendarCarouselContainer from './sections/EventCalendarCarouselContainer';
import EventCategoriesContainer from './sections/EventCategoriesContainer';
import EventsAllUpcomingCarouselContainer from './sections/EventsAllUpcomingCarouselContainer';

const EventsMainContainer: FC = () => {
  return (
    <Container>
      <EventsAllUpcomingCarouselContainer />
      <Spacer h="30px" />
      <EventCalendarCarouselContainer containerWidth={976} scrollBy={828} />
      <Spacer h="20px" />
      <CommunityPrivateChannelContainer/>
      <EventCategoriesContainer />
    </Container>
  );
};

export default EventsMainContainer;
